import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Sequência da rota (Iter 99): otimização via OSRM + reordenação manual ↑/↓ das entregas ativas.
export function useRotaOrdem(ativosOrdenados, setItems) {
  const [rotaBusy, setRotaBusy] = useState(false);
  const [rotaResumo, setRotaResumo] = useState(null);

  const otimizarRota = async () => {
    setRotaBusy(true);
    try {
      const r = await api.post("/minhas-entregas/otimizar");
      setRotaResumo(r.data);
      const byId = Object.fromEntries(r.data.sequencia.map((s) => [s.id, s]));
      setItems((arr) => arr.map((x) => (byId[x.id] ? { ...x, ordem: byId[x.id].ordem, eta_min: byId[x.id].eta_min } : x)));
      toast.success(`Rota otimizada: ${r.data.paradas} parada(s) · ~${Math.round(r.data.duration_s / 60)} min`);
      if (r.data.sem_geo?.length) toast.warning(`${r.data.sem_geo.length} entrega(s) em bairro sem localização ficaram no fim`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível otimizar a rota"); }
    finally { setRotaBusy(false); }
  };

  const moverOrdem = async (id, dir) => {
    const ids = ativosOrdenados.map((x) => x.id);
    const i = ids.indexOf(id), j = i + dir;
    if (i < 0 || j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    setRotaBusy(true);
    try {
      const r = await api.put("/minhas-entregas/reordenar", { ids });
      setItems((arr) => arr.map((x) => (r.data.ordem[x.id] ? { ...x, ordem: r.data.ordem[x.id], eta_min: null } : x)));
      setRotaResumo(null);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao reordenar"); }
    finally { setRotaBusy(false); }
  };

  return { rotaBusy, rotaResumo, otimizarRota, moverOrdem };
}
